<template>
    <div >
        <div class="formItem flex">
            <span>收件人<i>*</i></span>
            <p class="input inputa" style="position: relative">
              <template v-for="(item,index) in receive_data">
                <span>{{ item.customer_name }}<{{ item.customer_email }}>
                  <a-icon type="close-circle" @click="removeUser(item.a_customer_id,1)"/></span>
                <template v-if="item.user_emails" v-for="(items,index) in item.user_emails">
                  <span>{{ items.customer_name }}<{{ items.customer_email }}>
                    <a-icon type="close-circle" @click="removeUser(items.id,2)"/></span>
                  </template>
              </template>
              <span class="error">{{ error.customer_ids }}</span>
            </p>
            <a-icon type="plus-circle" @click="addUser(1)"  style="float: right;font-size:20px;position: relative;top:5px"/>
        </div>
        <div class="formItem flex">
            <span>主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题<i>*</i></span>
            <p class="input">
                <a-input placeholder=" " :maxLength=200 v-model="form.theme" @blur='()=>{  if(this.form.theme.trim()!=""){ this.error.theme=""}}' />
                <span class="error">{{error.theme}}</span>
            </p>
        </div>
        <div class="formItem flex">
            <span>内&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;容<i>*</i></span>
            <span class="input">
            <ckeditor4 ref="ckeditor" :parameter="1" :value="contenta" v-on:input="ckeditorContent" @changCkNums=" (type,data)=>{ this.error.content=''} "   ></ckeditor4>
<!--                @instanceReadyCk="instanceReadyCk "-->
                <span class="error">{{error.content}}</span>
            </span>
        </div>
        <div class="formItem flex">
            <span></span>
            <span class="input">
                 <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button  @click="onClose">
                取消
            </a-button>
            </span>
        </div>


        <a-modal v-model="visible" title="添加收件人" on-ok="handleOk" width="60%" class="writerModal" :cancel="()=>{  } ">
           <div class="topBtn " style="text-align: right;margin-bottom: 10px">
             <div class="seachList"><span class="name">网站类型：</span>
               <a-select v-model="seach.site_type" class="seachs" allowClear >
                 <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.siteTypeList">
                   {{item.name}}
                 </a-select-option>
               </a-select>
             </div>
             <div class="seachList"><span class="name">上线状态：</span>
               <a-select v-model="seach.status" class="seachs" allowClear  >
                 <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.statusList">
                   {{item.name}}
                 </a-select-option>
               </a-select>
             </div>
             <a-input  v-model="seach.keyword" style="width: 150px;margin-right: 10px;position: relative;top:1px"/>
               <a-button type="primary" class="seachBtn" @click="addUser(1)" style="margin-right: 10px"> 查询</a-button>
               <a-button class="seachBtn" @click='()=>{this.seach={ keyword:"", site_type:"", status:"", };this.addUser()}'>重置</a-button></div>
            <a-table  size="middle" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns" :data-source="data" :pagination="pagination" rowKey="id">
                <a slot="name" slot-scope="text">{{ text }}</a>
            </a-table>

            <template slot="footer">
                <a-button key="submit" type="primary"   @click="handleOk">
                确定
                </a-button>
                <a-button key="back" @click="()=>{this.visible = false;}">
                    取消
                </a-button>
            </template>
        </a-modal>

    </div>
</template>

<script>
    import ckeditor4 from '../Components/ckeditors'
    import API from "./api";
    const columns = [
        {
            title: '客户名称',
            dataIndex: 'customer_name',
            ellipsis: true,
            width: "20%",
        },
        {
            title: '网址',
            ellipsis: true,
            dataIndex: 'domain',
        },
        {
            title: '邮箱',
            ellipsis: true,
            dataIndex: 'customer_email',
        },
        {
            title: '模板编号',
            ellipsis: true,
            dataIndex: 'code',
            width: "80px",
        }
    ];
    export default {
        name: "WriteLetters",
        props: {
            content: {
                type: String,
                default: '请输入您的内容'
            }
        },
        data() {
            return {
                data:[],
                columns,
                selectedRowKeys: [],
              seach:{
                keyword:"",
                site_type:"",
                status:"",
              },
              seachList:{
                statusList:[],
                siteTypeList:[]
              },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.addUser.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                loading: false,
                visible: false,
                contenta: "",
                receive_data:[],
                form:{
                    customer_ids:[],
                    theme:"",
                    content:""
                },
                error:{
                    customer_ids:"",
                    theme:"",
                    content:""
                },

                id: this.$route.query.id,
            }
        },
        components:{ckeditor4},
        computed: {},
        mounted() {
            this.$route.query.ids?this.WriteLettersDetailAdd(this.$route.query.ids):this.$route.query.id?this.WriteLettersAdd():""
        },
        created() {
            this.$route.query.ids?this.$store.state.adminleftnavnum = "/CustomerManagement/Letter":this.$route.query.id?this.$store.state.adminleftnavnum = "/CustomerManagement/CustomerList":this.$store.state.adminleftnavnum = "/CustomerManagement/WriteLetters"
        },
        methods: {
            ckeditorContent(val) {
                this.form.content = val
            },
            changContent(){
                this.error.content=""

            },
            // instanceReadyCk(type){
            //     if(type==true){
            //         let _that=this
            //         this.$nextTick().then(function () {
            //             // if(_that.id!=undefined){ _that.editform(_that.id)}
            //         })
            //     }
            //     // this.id!=undefined&&this.editform(this.id)
            // },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            handleOk(e) {
            if(this.selectedRowKeys.length<1){
                this.$message.warning('请至少选择一个联系人');
                return
            }
                this.WriteLettersAdd(this.selectedRowKeys)
                this.visible = false;
            },
            removeUser(id,type){
                this.receive_data.map((item,index,arr)=>{
                  if(type==2){
                    item.user_emails.map((items,indexs)=>{
                      if(items.id==id) this.receive_data[index].user_emails.splice(indexs, 1);
                    })
                  }else{
                    if(item.a_customer_id==id)this.receive_data.splice(index, 1);
                  }
                })
            },
            addUser(page){
                this.selectedRowKeys=this.receive_data.map((item, index,arr)=>{
                    return item.a_customer_id
                });
                API.writeLetters.SEARCH_CUSTOMER({page: page || 1,...this.seach}).then(res => {
                  this.seachList.statusList=res.data.data.status
                  this.seachList.siteTypeList=res.data.data.siteTypeList
                    this.data=res.data.data.info.data
                    this.pagination.total = res.data.data.info.total
                    this.pagination.pageSize = res.data.data.info.per_page
                    this.pagination.current = res.data.data.info.current_page
                    this.visible = true;
                })

            },
            onSubmit(){
                let checkForm=true
                let _that=this
                this.$refs.ckeditor.$emit("getText")
              console.log(this.receive_data)
              // return
              let customerIds=[]
              let customerItemIds=[]
              this.receive_data.map((item,index)=>{
                customerItemIds=[]
                if(item.user_emails&&item.user_emails.length>0){
                  item.user_emails.map((items,indexs)=>{
                    customerItemIds.push(items.id)
                  })
                  customerIds.push({id:item.a_customer_id,user_ids :customerItemIds})}else{
                  customerIds.push({id:item.a_customer_id,user_ids:[]})
                }
              })
              // console.log("***",customerIds)
              // return
              // this.form.customer_ids =this.receive_data.map((item, index,arr)=>{ return item.a_customer_id })
              this.form.customer_ids =customerIds
                if(this.form.customer_ids.length<1){ this.error.customer_ids="请选择收件人";checkForm=false }
                if(this.form.theme.trim()==""){ this.error.theme="请输入主题";checkForm=false}
                if(this.form.content.trim()==""){this.error.content="请输入内容";checkForm=false}
                if(checkForm){
                    this.$confirm({
                        title: '提示',
                        content: '确定要发送么?',
                        onOk() {
                            let submitKey = 'submitupdatable';
                            let hide = _that.$message.loading({content:'正在发送中', key:submitKey} )
                            // let _that=this
                            API.writeLetters.SUMBET_FORM({..._that.form}).then(res => {
                                if (res.data.code === 200) {
                                    _that.$message.success({ content:res.data.msg, key:submitKey , duration: 2 })
                                    setTimeout(() => { _that.onClose() }, 1500)
                                }
                                if (res.data.code === 400) {
                                    // alert(123)
                                    // console.log("***********************",res.data.msg)
                                    // Vue.prototype.$message.error({ content:"提交失败,请重试！", key:submitKey, onClose })
                                    _that.$message.destroy()
                                    res.data.msg.map((item, index) => {
                                        _that.error[item.field] = item.msg
                                    })
                                }
                            })
                        },
                        onCancel() {},
                    });

                }
            },
            onClose(){
                this.$route.query.ids?this.$router.push({path: '/CustomerManagement/Letter'}):this.$router.push({path: '/CustomerManagement/CustomerList'})
            },
            WriteLettersAdd(ids) {
                this.error.customer_ids=""
                API.writeLetters.ADD_DATA({customer_ids:ids||this.id.split(",")}).then(res => {
                    this.receive_data=res.data.data.receive_data
                })
            },
            WriteLettersDetailAdd(id) {
                let _that=this
                API.writeLetters.ADD_DETAILS_DATA(id).then(res => {
                    this.receive_data=res.data.data.info.all_receive_data;

                  let customerIds=[]
                  let customerItemIds=[]
                  this.receive_data.map((item,index)=>{
                    customerItemIds=[]
                    if(item.user_emails&&item.user_emails.length>0){
                      item.user_emails.map((items,indexs)=>{
                        customerItemIds.push(items.id)
                      })
                      customerIds.push({id:item.a_customer_id,user_ids :customerItemIds})}else{
                      customerIds.push({id:item.a_customer_id,user_ids:[]})
                    }
                  })
                    this.form={
                        customer_ids:customerIds,
                        theme:res.data.data.info.theme,
                        content:res.data.data.info.content,
                        create_time_format:res.data.data.info.create_time_format
                    }
                    this.next_id=res.data.data.next_id
                    this.$nextTick().then(function () {
                        setTimeout(() => {
                            _that.contenta = res.data.data.info.content_text
                        }, 300)
                    })

                })
            },

        }
    }
</script>

<style scoped>
.formItem{width: 60%;margin-bottom: 30px}
.formItem span i{color: #f00}
.formItem span:first-child{ width:50px;text-align: right}
.formItem .input{width: calc(100% - 55px);position: relative}
.formItem .inputa{width: calc(100% - 80px);min-height: 32px; position: relative; display: inline-block;padding: 4px 11px; color: rgba(0, 0, 0, 0.65); font-size: 14px; line-height: 1.5; background-color: #fff; border: 1px solid #d9d9d9; border-radius: 4px;}
.formItem .inputa span{margin-right:8px;display: inline-block;width: unset}
.formItem .inputa i{color: rgba(0, 0, 0, 0.3);display: inline-block;margin-left: 5px;font-weight: 400;cursor: pointer}
.writerModal>>>.ant-modal-body{padding: 15px!important;}
.error{color: #f00;position: absolute;bottom: -20px;left: 0}
.seachList{display: inline-block;width:240px;margin-right: 10px}
.ant-select{width: calc(100% - 70px)}
</style>
